//ts-nocheck
import clsx from 'clsx';
import * as React from 'react';
import { isInclude, jsonParse } from '../../../lib/utils';
import Checkbox from '../../baseElement/checkbox';
import { Trn } from '../../../translations/language';
import { useEffect, useMemo, useRef, useState } from 'react';
import './MSelectbox.css';

function Select(props) {
  const {
    value,
    search,
    options,
    children,
    onChange,
    getValue,
    multiple,
    className,
    isDisabled,
    size = 'md',
    placeholder,
    id = 'select',
    ...other
  } = props;

  const [, setSelectedEvent] = useState();
  const [searchInput, setSearchInput] = useState('');
  const [showDropDown, setShowDropDown] = useState(false);
  const [selected, setSelected] = useState({ label: '', value: '' });

  useEffect(() => {
    init();

  }, [value]);

  const selectTarget = useRef();

  useOutsideAlerter(selectTarget, () => {
    setShowDropDown(false);
  });

  const OptionsJsx = useMemo(() => {
    const optionList = [];
    if (children) {
      for (
        let i = 0;
        typeof children !== 'string' || i < children.length;
        i++
      ) {
        // @ts-ignore
        if (children[i]) {
          // @ts-ignore
          const { props: itemProps } = children[i];
          if (
            itemProps &&
            (itemProps.children.includes(searchInput) ||
              itemProps.value.includes(searchInput))
          ) {
            optionList.push(
              <div
                key={i}
                onClick={() =>
                  handleSelect({
                    label: itemProps.children,
                    value: itemProps.value,
                  })
                }
                className={clsx('select-option', multiple && 'multiple')}
              >
                {multiple ? (
                  <Checkbox
                    id={`${id}-${i}`}
                    value={itemProps.value}
                    label={itemProps.label}
                    checked={isInclude(selected.value, itemProps.value)}
                  />
                ) : (
                  <span className="select-option-text">
                    {itemProps.children}
                  </span>
                )}
              </div>
            );
          }
        }
      }
    } else if (options && options.length) {
      for (let i in options) {
        if (
          (options[i].label && options[i].label.includes(searchInput)) ||
          (options[i].value && options[i].value.includes(searchInput))
        ) {
          if (multiple) {
            optionList.push(
              <li
                key={i}
                data-multiple="true"
                onClick={() => handleSelect(options[i])}
              >
                <Checkbox
                  id={`${id}-${i}`}
                  checked={isInclude(selected.value, options[i].value)}
                  {...options[i]}
                />
              </li>
            );
          } else {
            optionList.push(
              <li key={i} onClick={() => handleSelect(options[i])} className="">
                <span className="">{options[i].label}</span>
              </li>
            );
          }
        }
      }
    }
    return optionList;

  }, [searchInput, selected.value, options]);

  const handleSelect = ({ label, value }) => {
    // setSelectLabel()
    setSelected((list) => {
      let newValue;
      const currentSelected = list
        ? { ...jsonParse(JSON.stringify(list)) }
        : { label: '', value: '' };
      if (multiple) {
        let valueList = currentSelected.value;
        if (!valueList) {
          valueList = [];
        }
        let labelList = currentSelected.label;
        if (!labelList) {
          labelList = [];
        }
        if (!valueList.length) {
          valueList.push(value);
          labelList.push(label);
        } else {
          const index = valueList.indexOf(value);
          if (index > -1) {
            valueList.splice(index, 1);
            labelList.splice(index, 1);
          } else {
            valueList.push(value);
            labelList.push(label);
          }
        }
        newValue = { label: labelList, value: valueList };
      } else {
        newValue = { label, value };
      }

      if (!multiple) {
        setShowDropDown(false);
      }
      getValue?.(newValue?.value);

      return newValue;
    });

    // todo
    // onChange?.(value);
  };

  const handleChangeSearch = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    setSelectedEvent(e);
    setShowDropDown(true);
  };

  const handleShowDropDown = () => {
    if (!isDisabled) {
      setShowDropDown(!showDropDown);
    }
  };

  const init = () => {
    let selected = { label: [], value: [] };

    let val = value;
    if (
      typeof value === 'string' &&
      (value.includes('[') || value.includes('{'))
    ) {
      val = jsonParse(value);
    }
    for (let i in options) {
      let allow = false;
      if (Array.isArray(val) && isInclude(val, options[i].value)) {
        allow = true;
      }
      if (options[i].value === val) {
        allow = true;
      }
      if (allow) {
        selected.label.push(options[i].label);
        selected.value.push(options[i].value);
      }
    }
    setSelected(selected);
  };

  return (
    <div
      ref={selectTarget}
      className={clsx('position-relative', className)}
      {...other}
    >
      <div className="select-style" onClick={handleShowDropDown}>
        <div className="outline">
          <span className="caret" />
          <input
            readOnly
            disabled={isDisabled}
            className="select-input form-control"
            placeholder={placeholder || Trn({ text: 'select' })}
            value={
              Array.isArray(selected.label)
                ? selected.label.join(',')
                : selected.label
            }
          />

          <div className="form-notch">
            <div className="form-notch-leading" />
            <div className="form-notch-middle" />
            <div className="form-notch-trailing" />
          </div>
          {/*<div className="fake-value">{selectedValue}</div>*/}
        </div>

        <select
          className={clsx(
            'form-select d-none',
            `form-select-${size}`,
            className
          )}
        >
          {children}
          {options && options.length
            ? options.map((item) => (
                <option value={item.value} key={item.value}>
                  {item.label}
                </option>
              ))
            : null}
        </select>
      </div>

      {showDropDown && (
        <div className="select-dropDown-style w-100 bg-white position-absolute form-control border-top-0">
          <div className="select-dropdown">
            <ul className="dropdown-content select-dropdown fadeElement fadeIn">
              {search && (
                <div className="input-box">
                  <input
                    className="ps-2"
                    value={searchInput}
                    onChange={handleChangeSearch}
                    placeholder={Trn({ text: 'search' })}
                  />
                </div>
              )}
              {OptionsJsx}
            </ul>
            {/*<div className="select-options-wrapper">*/}
            {/*  <div className="select-options-list">{OptionsJsx}</div>*/}
            {/*</div>*/}
          </div>
        </div>
      )}
    </div>
  );
}

const Options = (props) => {
  const { value, selected, label } = props;
  return (
    <option value={value} selected={selected}>
      {label}
    </option>
  );
};
Select.Option = Options;

export default Select;

function useOutsideAlerter(ref, callback) {
  useEffect(() => {
    // Alert if clicked on outside of element
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };


  }, [ref]);
}
